import { useState, useEffect } from 'react';

// Mobile breakpoint per EpicPlan-Mobile-Master-Doc Part 2: `<= 768px` = mobile.
// This app is Create React App (a pure client-side SPA, no SSR), so a
// matchMedia hook is safe — there is no hydration mismatch to guard against.
export const MOBILE_BREAKPOINT = 768;
const QUERY = `(max-width: ${MOBILE_BREAKPOINT}px)`;

// Returns true while the viewport is at/below the mobile breakpoint, and
// updates live on resize / orientation change. Single source of truth for
// the desktop-vs-mobile branch in SchedulingScreen.
export function useIsMobile() {
  const [isMobile, setIsMobile] = useState(
    () => typeof window !== 'undefined' && window.matchMedia(QUERY).matches
  );

  useEffect(() => {
    if (typeof window === 'undefined') return undefined;
    const mql = window.matchMedia(QUERY);
    const onChange = (e) => setIsMobile(e.matches);
    // Re-sync once on mount in case the viewport changed before the effect ran.
    setIsMobile(mql.matches);
    // Safari < 14 only supports the deprecated add/removeListener API.
    if (mql.addEventListener) mql.addEventListener('change', onChange);
    else mql.addListener(onChange);
    return () => {
      if (mql.removeEventListener) mql.removeEventListener('change', onChange);
      else mql.removeListener(onChange);
    };
  }, []);

  return isMobile;
}

export default useIsMobile;
